module.exports = __webpack_public_path__ + "img/nav-exit.5636086b.svg";